import { useStore } from '../store/useStore';

/**
 * Promise-shaped stand-ins for `window.prompt` / `window.confirm`, rendered by
 * `PromptDialog` / `ConfirmDialog`. Same call shape as the natives, so call
 * sites read the same — but themed, translated, and non-blocking.
 */

/** Ask for a line of text. Resolves `null` when cancelled or left empty. */
export function askPrompt(opts: {
  title: string;
  initial?: string;
  confirmLabel?: string;
}): Promise<string | null> {
  return new Promise((resolve) => {
    useStore.getState().setPrompt({ key: Symbol('prompt'), ...opts, resolve });
  });
}

/** Tell the user something. One button; resolves once dismissed. */
export function askNotice(opts: {
  title: string;
  body?: string;
  confirmLabel?: string;
}): Promise<boolean> {
  return new Promise((resolve) => {
    useStore.getState().setConfirm({ key: Symbol('notice'), ...opts, acknowledge: true, resolve });
  });
}

/** Ask for a yes/no. Resolves `false` on cancel, Escape, or overlay click. */
export function askConfirm(opts: {
  title: string;
  body?: string;
  confirmLabel?: string;
  danger?: boolean;
}): Promise<boolean> {
  return new Promise((resolve) => {
    useStore.getState().setConfirm({ key: Symbol('confirm'), ...opts, resolve });
  });
}
